var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_2459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 0 10 0ZM9.97973 5.56042C10.9021 5.57255 11.6661 6.32343 11.92 7.28027C12.0167 7.67067 12.0277 8.06673 11.9301 8.48023C11.783 9.06238 11.4885 9.63103 10.9397 9.98037L11.7395 10.3603L13.6398 11.2804C13.8265 11.3604 13.9197 11.5204 13.9197 11.7604V13.5999C13.9197 13.9793 13.9498 14.3065 13.4796 14.4402H6.47987C6.02763 14.4337 6.0089 13.9757 6.0195 13.5999V11.7604C6.0195 11.5204 6.11965 11.3535 6.31965 11.2601L8.2795 10.3603L9.04002 10C8.69335 9.77333 8.41998 9.46028 8.21998 9.06028C7.97982 8.53222 7.8846 7.84672 8.05978 7.2201C8.28125 6.37073 8.97485 5.60763 9.97973 5.56042ZM6.71985 6.40008C7.0132 6.40008 7.27963 6.487 7.51962 6.66033C7.45307 6.84697 7.3967 7.04382 7.3499 7.2505C7.30325 7.45713 7.27962 7.6735 7.27962 7.90018C7.27962 8.23353 7.32622 8.5535 7.41955 8.86018C7.51287 9.16683 7.64638 9.44713 7.81977 9.70048C7.73975 9.80713 7.63332 9.90037 7.49997 9.98037L6.01947 10.6605C5.81947 10.7671 5.65948 10.9167 5.53948 11.1101C5.41948 11.3034 5.35965 11.5204 5.35965 11.7604V13.5999H3.90005C3.6883 13.5966 3.54528 13.3832 3.53973 13.1605V11.4204C3.53973 11.2204 3.6128 11.0868 3.75947 11.0201L5.97962 10C5.406 9.6474 5.12927 9.01008 5.10007 8.3004C5.11017 7.42603 5.68327 6.47272 6.71985 6.40008ZM13.2795 6.40008C14.201 6.41465 14.8667 7.32827 14.9 8.30042C14.8949 8.94367 14.6438 9.5648 14.0597 9.98038L16.2399 11.0202C16.3866 11.1002 16.4596 11.2337 16.4596 11.4204V13.1605C16.4574 13.367 16.346 13.5789 16.1 13.5999H14.5998V11.7604C14.5998 11.5204 14.54 11.3034 14.42 11.1101C14.3 10.9167 14.14 10.7671 13.94 10.6605C13.3183 10.3715 12.6042 10.1641 12.1397 9.68022C12.4864 9.14688 12.6596 8.55353 12.6596 7.90018C12.6596 7.48685 12.5865 7.07995 12.4399 6.67995C12.6807 6.52093 12.9658 6.40455 13.2795 6.40008Z",
    fill: "url(#paint0_linear_227_2459)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_227_2459",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#982815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7878"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_2459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.779f0e762af63d9e2a4019de5028f869.svg";
export { ForwardRef as ReactComponent };